<template>
  <div>
    <!-- 资金/平台账单 -->
    <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.platformBillList')"></baseBreadcrumb>
    <div class="body">
      <!-- 平台账单及账户中心 tabs，默认 pingpong。 -->
      <div class="tabs">
        <el-tabs v-model="datas.channel" type="card" @tab-click="handleTabClick">
          <el-tab-pane label="pingpong" name="pingpong"></el-tab-pane>
          <el-tab-pane label="payoneer" name="payoneer"></el-tab-pane>
          <el-tab-pane :label="$t('message.platformBillAccountCenter')" name="accountCenter"></el-tab-pane>
        </el-tabs>
      </div>
      <accountBalanceCenter v-if="datas.channel == 'accountCenter'" />
      <div v-else class="bill-list-content">
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 开始日期 -->
          <div class="item">
            <el-date-picker v-model="datas.start_date" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="00:00:00" value-format="yyyy-MM-dd HH:mm:ss" clearable>
            </el-date-picker>
          </div>
          <!-- 结束日期 -->
          <div class="item">
            <el-date-picker v-model="datas.end_date" :placeholder="$t('message.dateClosed')" class="Container"
              type="datetime" default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss" clearable>
            </el-date-picker>
          </div>
          <!-- 订单号 -->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.platformBillOrderSnPlaceholder')"
              clearable></el-input>
          </div>
          <!-- 交易编号 -->
          <div class="item">
            <el-input v-model="datas.order_id" :placeholder="$t('message.platformBillOrderIdPlaceholder')"
              clearable></el-input>
          </div>
          <!-- 展示类型 -->
          <div class="item">
            <el-input v-model="datas.display_type" :placeholder="$t('message.platformBillDisplayTypePlaceholder')"
              clearable></el-input>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
          <!-- 重置 -->
          <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button>
          <!-- 账单费用导出 -->
          <el-button type="success" @click="feeExport">
            {{ $t("message.platformBillFeeExport") }}
          </el-button>
        </div>
      </div>
      <!-- 当前筛选条件下全部账单的汇总 -->
      <div class="summary">
        <div class="summary-item">
          <span class="summary-label">{{ $t('message.platformBillAmountTotal') }}</span>
          <span class="summary-value">{{ summary.total_amount }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">{{ $t('message.platformBillServiceFeeTotal') }}</span>
          <span class="summary-value">{{ summary.total_service_fee }}</span>
        </div>
      </div>
      <!-- pingpong 列表 -->
      <div class="table" v-if="datas.channel == 'pingpong'">
        <ol>
          <li class="flex05">NO</li>
          <!-- 交易编号 -->
          <li class="flex2">{{ $t('message.platformBillOrderId') }}</li>
          <!-- 交易创建时间 -->
          <li>{{ $t('message.platformBillCreateTime') }}</li>
          <!-- 币种 -->
          <li class="flex05">{{ $t('message.platformBillCurrency') }}</li>
          <!-- 金额 -->
          <li>{{ $t('message.sum') }}</li>
          <!-- 汇率 -->
          <li>{{ $t('message.rate') }}</li>
          <!-- 手续费 -->
          <li>{{ $t('message.poundage') }}</li>
          <!-- 展示类型 -->
          <li class="flex2">{{ $t('message.platformBillDisplayType') }}</li>
          <!-- 资金方向 -->
          <li>{{ $t('message.platformBillDirection') }}</li>
          <!-- 余额 -->
          <li>{{ $t('message.residualGold') }}</li>
          <!-- 交易对手 -->
          <li class="flex2">{{ $t('message.platformBillTransactingPart') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber || index + 1 }}</li>
          <li class="flex2">{{ item.order_id }}</li>
          <li>
            <div class="time">{{ item.create_time }}</div>
          </li>
          <li class="flex05">{{ item.currency }}</li>
          <li>{{ item.amount }}</li>
          <li>{{ item.exchange_rate }}</li>
          <li>{{ item.service_fee }}</li>
          <li class="flex2">{{ item.display_type }}</li>
          <li>{{ item.direction }}</li>
          <li>{{ item.balance }}</li>
          <li class="flex2">{{ item.transacting_part }}</li>
        </ul>
        <div v-if="tableData == false" class="No_data">{{ $t('message.noDataYet') }}</div>
      </div>
      <!-- payoneer 列表 -->
      <div class="table" v-else>
        <ol>
          <li class="flex05">NO</li>
          <!-- 交易ID -->
          <li>{{ $t('message.platformBillTransactionId') }}</li>
          <!-- 账户ID -->
          <li class="flex15">{{ $t('message.platformBillAccountId') }}</li>
          <!-- 交易类型 -->
          <li>{{ $t('message.platformBillType') }}</li>
          <!-- 状态 -->
          <li>{{ $t('message.status') }}</li>
          <!-- 交易金额 -->
          <li>{{ $t('message.sum') }}</li>
          <!-- 汇率 -->
          <li>{{ $t('message.rate') }}</li>
          <!-- 手续费 -->
          <li>{{ $t('message.poundage') }}</li>
          <!-- 币种 -->
          <li class="flex05">{{ $t('message.platformBillCurrency') }}</li>
          <!-- 交易描述 -->
          <li class="flex2">{{ $t('message.platformBillDescription') }}</li>
          <!-- 交易发生时间 -->
          <li>{{ $t('message.platformBillTransactionTime') }}</li>
          <!-- 交易后余额 -->
          <li>{{ $t('message.platformBillRunningBalance') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber || index + 1 }}</li>
          <li>{{ item.transaction_id }}</li>
          <li class="flex15">{{ item.account_id }}</li>
          <li>{{ item.type }}</li>
          <li>{{ item.status }}</li>
          <li>{{ item.amount }}</li>
          <li>{{ item.exchange_rate }}</li>
          <li>{{ item.service_fee }}</li>
          <li class="flex05">{{ item.currency }}</li>
          <li class="flex2">{{ item.description }}</li>
          <li>
            <div class="time">{{ item.transaction_time }}</div>
          </li>
          <li>{{ item.running_balance }}</li>
        </ul>
        <div v-if="tableData == false" class="No_data">{{ $t('message.noDataYet') }}</div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import accountBalanceCenter from './components/accountBalanceCenter'

export default {
  components: {
    accountBalanceCenter,
  },
  data() {
    return {
      datas: {
        channel: 'pingpong',
        start_date: '',
        end_date: '',
        order_sn: '',
        order_id: '',
        display_type: '',
        page: 1,
        pageSize: 20,
      },
      tableData: [],
      total: 0,
      summary: {
        total_amount: 0,
        total_service_fee: 0,
      },
    };
  },
  created(){
    this.feeList();
  },
  methods: {
    // 账户中心由独立组件加载余额；平台账单切换时继续按原条件查询。
    handleTabClick() {
      if (this.datas.channel == 'accountCenter') return
      this.search()
    },
    // 重置（保留当前账单类型 tab）
    reset() {
      this.datas = {
        channel: this.datas.channel || 'pingpong',
        start_date: '',
        end_date: '',
        order_sn: '',
        order_id: '',
        display_type: '',
        page: 1,
        pageSize: 20,
      };
      this.tableData = [];
      this.total = 0;
      this.search();
    },
    // 搜索 / 切换账单类型
    search() {
      this.datas.page = 1;
      this.tableData = [];
      this.total = 0;
      this.summary = {
        total_amount: 0,
        total_service_fee: 0,
      };
      this.feeList();
    },
    // 平台账单列表（pingpong / payoneer 字段不同，按 channel 区分展示）
    feeList() {
      this.$api.financialApi.feeList(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg || (res.data && res.data.msg));
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.summary = res.data.summary
      });
    },
    // 账单费用导出，参数与列表一致
    feeExport() {
      if (!this.datas.start_date || !this.datas.end_date) {
        return this.$message.error(this.$t('message.pleaseSelectDateRange'));
      }
      this.$api.financialApi.feeExport(this.datas, {
        responseType: 'blob'
      }).then(res => {
        const blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `平台账单_${this.datas.channel}.xlsx`;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }).catch(() => {
        this.$message.error(this.$t('message.platformBillFeeExportFail'));
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.feeList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.feeList();
    },
  },
};
</script>
<style lang='scss' scoped>
.tabs {
  margin-top: 10px;
}

.search {
  margin: 24px 0 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;

    .item {
      width: 200px;
    }

    /deep/.el-date-editor {
      width: 200px;
    }
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.summary {
  display: flex;
  align-items: center;
  gap: 48px;
  margin-bottom: 16px;
  padding: 16px 20px;
  font-size: 17px;
  color: #333;
  background: #f5f8ff;
  border: 1px solid #d9e5ff;
  border-left: 4px solid #2c96e7;
  border-radius: 4px;

  .summary-item {
    display: flex;
    align-items: baseline;
    gap: 10px;
  }

  .summary-label {
    font-weight: 600;

    &::after {
      content: "：";
    }
  }

  .summary-value {
    color: #fa5058;
    font-size: 20px;
    font-weight: bold;
  }
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
    word-break: break-all;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;

    &:hover {
      background-color: #fff;
    }
  }

  .time {
    width: 80px;
    text-align: center;
  }
}
</style>
